// FW/HW display helpers (Ram, 2026-08-04): versions are STORED encoded
// (dotless EMS convention / normalized module strings) but must DISPLAY as
// semver-ish x.y.z. The convention: x and y are single digits 0-9; z is 0-99,
// shown as 1 digit when 0-9 and 2 digits when 10-99 (no padding).
//   '302'  -> 3.0.2      '2221' -> 2.2.21     '226' -> 2.2.6
//   '1010' -> 1.0.10     '3002' -> 3.0.2      '101' (hw) -> 1.0.1
// Mirrors the backend's normalizeFirmwareVersion arithmetic: 3-char inserts a
// 0 before the last digit; 5-digit legacy folds (20010 -> 2.0.10). Anything
// unparseable (empty, 'unset', already-dotted, words) is returned untouched —
// display must never lie about what is stored.

function encodedToNorm(value) {
    if (value === undefined || value === null) return 0;
    const s = String(value).trim();
    if (!s || !/^\d+$/.test(s)) return 0;
    if (s.length === 3) {
        const p = parseInt(s[0] + s[1] + '0' + s[2], 10);
        return Number.isNaN(p) ? 0 : p;
    }
    const n = parseInt(s, 10);
    if (Number.isNaN(n)) return 0;
    if (n >= 10000 && n <= 99999) {
        return Math.floor(n / 10000) * 1000 + Math.floor((n % 10000) / 100) * 100 + (n % 100);
    }
    return n;
}

export function fwDisplay(value) {
    const n = encodedToNorm(value);
    if (n < 100 || n > 9999) return value === undefined || value === null ? '' : String(value);
    return `${Math.floor(n / 1000)}.${Math.floor((n % 1000) / 100)}.${n % 100}`;
}

// HW is x.y.z with z single digit today ('100' -> 1.0.0, '101' -> 1.0.1) —
// same arithmetic applies.
export const hwDisplay = fwDisplay;
